import { render, staticRenderFns } from "./ConfigItemValueList.vue?vue&type=template&id=1b2f09cd&scoped=true&"
import script from "./ConfigItemValueList.vue?vue&type=script&lang=js&"
export * from "./ConfigItemValueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2f09cd",
  null
  
)

export default component.exports